import { gql, TypedDocumentNode } from '@apollo/client';

import { MeQuery, MeQueryVariables } from '../generated';

export const ME: TypedDocumentNode<MeQuery, MeQueryVariables> = gql`
  query Me {
    me {
      id
      email
      settings {
        aiAssistEditChatModel
        colorMode
      }
      effectiveAiAssistEditChatModel
    }
  }
`;
